<template>
    <div>
      <pc v-if="!isShowMobile"/>
      <mobile v-else />
    </div>
</template>

<script>
import pc from '@/pc/pc_page'
import mobile from '@/mobile/mobile_page'
export default {
  name: 'Layout',
  components: {
    pc,
    mobile
  },
  data() {
    return {
      isShowMobile: false
    }
  },
  created() {
    var flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    if (flag) {
      this.isShowMobile = true
    } else {
      this.isShowMobile = false
    }
  }
}
</script>

<style>
</style>
